var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"dark":"","bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"text":"","color":"indigo darken-4","fab":"","small":""}},'v-btn',attrs,false),on),[_c('a',{attrs:{"href":_vm.urlRespuestas,"target":"_blank"}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)])]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }